export default "/images/vendor/flag-icons/flags/4x3/cv.svg?aa02126ce32724f97a9cfb1067461f83";